import React, { useState, useEffect } from 'react';
import { db } from '../common/Firestore';
import * as COLLECTION from '../common/constant/collections'
import { collection, getDocs, setDoc, doc } from "firebase/firestore";

export const useScreenConfig = () => {
    const [screens, setScreens] = useState(null);

    useEffect(() => {
        getScreenConfig()
    }, [])

    const getScreenConfig = async () => {
        let sc = []
        const screensData = await getDocs(collection(db, COLLECTION.SUB_SCREEN));
        if (screensData) {
            // console.log("All Screens: ", screensData)
            screensData.forEach((screen) => {
                if (screen.exists) {
                    // console.log("Screen: ", screen.data())
                    sc.push({ key: screen.id, ...screen.data() })
                }
            })
        }
        setScreens(sc)
    }

    const updateScreenConfig = async (newConfig) => {
        if (newConfig) {
            // if(newConfig.icon && newConfig.icon.file) {

            // }
            try {
                const res = await setDoc(doc(db, COLLECTION.SUB_SCREEN, newConfig.key), newConfig)
                if (res) {
                    let finalScreens = (screens && Array.isArray(screens)) ? [...screens] : []
                    let oldConfig = finalScreens.find(t => t.key === newConfig.key)
                    if (oldConfig)
                        oldConfig = newConfig;
                    else finalScreens.push(newConfig)
                    setScreens(finalScreens)
                    return finalScreens
                }

            } catch (error) {
                console.error("Cannot save config: ", error)
            }
        } else return
    }

    return { screens, updateScreenConfig };
}